function removeAndCopy(hashtag, array) {
    const result = []

    for (let i of array) {

        if (typeof i == 'string' && i === hashtag.hashtag) {
            continue
        } else if (i.hashtag === hashtag.hashtag) {
            continue
        }
        result.push(i)
    }

    return result
}

const state = {
    overusedHashtags: [],
    goodHashtags: [],
    greatHashtags: [],
    unusedHashtags: [],
    instagramHashtags: [],
    instagramBannedHashtags: [],
    allHashtags: [],
    bookmarkedHashtags: [],
    hashtagCollectorOpened: false
}

const getters = {
    getOverusedHashtags: state => {
        return state.overusedHashtags
    },
    getGoodHashtags: state => {
        return state.goodHashtags
    },
    getGreatHashtags: state => {
        return state.greatHashtags
    },
    getUnusedHashtags: state => {
        return state.unusedHashtags
    },
    getInstagramHashtags: state => {
        return state.instagramHashtags
    },
    getInstagramBannedHashtags: state => {
        return state.instagramBannedHashtags
    },
    getAllHashtags: state => {
        return state.allHashtags
    },
    getBookmarkedHashtags: state => {
        return state.bookmarkedHashtags
    },
    openedHashtagCollector: state => {
        return state.hashtagCollectorOpened
    }
}

const mutations = {
    compareBookmarkedHashtags: (state, hashtags) => {
        state.goodHashtags = []
        state.greatHashtags = []
        state.unusedHashtags = []
        for (let hashtag of hashtags) {
            if (hashtag.color === 2) {
                state.goodHashtags.push(hashtag)
            } else if (hashtag.color === 3) {
                state.greatHashtags.push(hashtag)
            } else if (hashtag.color === 0) {
                state.unusedHashtags.push(hashtag)
            }
        }
    },
    compareSuggestedHashtags: (state, hashtags) => {
        state.goodHashtags = []
        state.greatHashtags = []
        state.unusedHashtags = []
        for (let i = 0; i < hashtags.length; i++) {
            if (hashtags[i].color === 2) {
                state.goodHashtags.push(hashtags[i])
            } else if (hashtags[i].color === 3) {
                state.greatHashtags.push(hashtags[i])
            } else if (hashtags[i].color === 0) {
                state.unusedHashtags.push(hashtags[i])
            }
       }
    },
    resetComparison: state => {
        state.overusedHashtags = []
        state.goodHashtags = []
        state.greatHashtags = []
        state.unusedHashtags = []
        state.instagramHashtags = []
        state.instagramBannedHashtags = []
        state.allHashtags = []
    },
    addToComparison: (state, hashtag) => {
        const exists = state.allHashtags.indexOf(hashtag.hashtag) > -1
        if (exists) {
            return
        }
        state.allHashtags.push(hashtag.hashtag)
        switch (hashtag.color) {
            case 0:
                state.unusedHashtags.push(hashtag)
                break
            case 1:
                state.overusedHashtags.push(hashtag)
                break
            case 2:
                state.goodHashtags.push(hashtag)
                break
            case 3:
                state.greatHashtags.push(hashtag)
                break
            case 4:
                state.instagramHashtags.push(hashtag)
                break
            case 5:
                state.instagramBannedHashtags.push(hashtag)
                break
        }
    },
    bookmarkHashtag: (state, hashtag) => {
        state.hashtagCollectorOpened = true
        const exists = state.bookmarkedHashtags.map(x => x.hashtag).indexOf(hashtag.hashtag) > -1
        if (exists) {
            return
        }
        state.bookmarkedHashtags.push(hashtag)
    },
    removeHashtag: (state, hashtag) => {
        let hashtagIndex = state.allHashtags.indexOf(hashtag.hashtag)
        console.log(hashtag)
        console.log(hashtagIndex)
        state.allHashtags = removeAndCopy(hashtag, state.allHashtags)

        switch (hashtag.color) {
            case 0:
                state.unusedHashtags = removeAndCopy(hashtag, state.unusedHashtags)
                break
            case 1:
                state.overusedHashtags = removeAndCopy(hashtag, state.overusedHashtags)
                break
            case 2:
                state.goodHashtags = removeAndCopy(hashtag, state.goodHashtags)
                break
            case 3:
                state.greatHashtags = removeAndCopy(hashtag, state.greatHashtags)
                break
            case 4:
                state.instagramHashtags = removeAndCopy(hashtag, state.instagramHashtags)
                break
            case 5:
                state.instagramBannedHashtags = removeAndCopy(hashtag, state.instagramBannedHashtags)
                break
        }
        if(!state.allHashtags) {
            this.resetComparison()
        }
    },
    removeBookmark: (state, hashtag) => {
        state.bookmarkedHashtags.splice(hashtag, 1)
    },
    resetBookmark: (state) => {
        state.bookmarkedHashtags = []
    },
    openHashtagCollector: (state) => {
        state.hashtagCollectorOpened = true
    },
    closeHashtagCollector: (state) => {
        state.hashtagCollectorOpened = false
    }
}

const actions = {
    setCompareBookmarkedHashtags: (context, payload) => {
        context.commit('compareBookmarkedHashtags', payload)
    },
    setCompareSuggestedHashtags: (context, payload) => {
        context.commit('compareSuggestedHashtags', payload)
    },
    setBookmarkHashtag: (context, payload) => {
        context.commit('bookmarkHashtag', payload)
    },
    setAddToComparison: (context, payload) => {
        context.commit('addToComparison', payload)
    },
    setResetComparison: context => {
        context.commit('resetComparison')
    },
    setRemoveHashtag: (context, payload) => {
        context.commit('removeHashtag', payload)
    },
    setRemoveBookmark: (context, payload) => {
        context.commit('removeBookmark', payload)
    },
    setResetBookmark: context => {
        context.commit('resetBookmark')
    },
    openHashtagCollector: context => {
        context.commit('openHashtagCollector')
    },
    closeHashtagCollector: context => {
        context.commit('closeHashtagCollector')
    }
}

export const comparison = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
